/**
 * A portal is "in downtime" when a scheduled outage window is set and `now`
 * falls inside it: start <= now < end. Half-open so back-to-back windows
 * never overlap and a window is over the instant its end passes.
 * Both bounds must be set; a half-configured window disables nothing.
 */
export function isPortalInDowntime(
  portal: { downtimeWindowStart: Date | null; downtimeWindowEnd: Date | null },
  now: Date
): boolean {
  const { downtimeWindowStart, downtimeWindowEnd } = portal;
  if (!downtimeWindowStart || !downtimeWindowEnd) {
    return false;
  }
  return downtimeWindowStart <= now && now < downtimeWindowEnd;
}
